import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

let sections = gsap.utils.toArray('.-scroll-snap');

sections.forEach((section) => {
    const overlay = section.querySelector('.-scroll-snap__overlay');
    gsap.fromTo(
        overlay,
        {
            '--overlay': -20,
            ease: 'none',
        },
        {
            '--overlay': 20,
            ease: 'none',
            scrollTrigger: {
                trigger: section,
                scrub: true,
            },
        }
    );
});
